import _enum from '../enum';

export default {
  [_enum.Product]: 'Producto',
  [_enum.Service]: 'Servicio',
  [_enum.Device]: 'Dispositivo',
  [_enum.Expense]: 'Subcategoria Gasto',
};
